import styled from 'styled-components'

export const FeaturesContainer = styled.div<{
  $background?: boolean
  $padding?: string
  $borderRadius?: string
}>`
  ${({ $background, $padding, $borderRadius, theme }) =>
    $background &&
    `
    background: ${theme.colors.background.secondary};
    border-radius: ${$borderRadius || theme.borderRadius.xlarge};
    padding: ${$padding || theme.spacing.xlarge};
  `}
`

export const FeaturesGrid = styled.div<{
  $columns?: number | 'auto'
  $minColumnWidth?: string
}>`
  display: grid;
  grid-template-columns: ${({ $columns, $minColumnWidth }) =>
    $columns === 'auto'
      ? `repeat(auto-fill, minmax(${$minColumnWidth || '180px'}, 1fr))`
      : `repeat(${$columns || 3}, 1fr)`};
  gap: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.medium};
`

export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.spacing.xsmall} 0;
`

export const FeatureIcon = styled.div`
  width: 18px;
  height: 18px;
  border-radius: ${({ theme }) => theme.borderRadius.circle};
  background: ${({ theme }) => theme.colors.primaryLight};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    color: ${({ theme }) => theme.colors.primary};
    width: 12px;
    height: 12px;
  }
`

export const FeatureText = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const ShowMoreButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  margin: ${({ theme }) => theme.spacing.default} auto 0;
  padding: ${({ theme }) => theme.spacing.xsmall}
    ${({ theme }) => theme.spacing.medium};
  background: transparent;
  border: none;
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  transition: color ${({ theme }) => theme.transitions.fast};

  &:hover {
    color: ${({ theme }) => theme.colors.primary};

    svg {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  svg {
    color: ${({ theme }) => theme.colors.text.tertiary};
    transition: color ${({ theme }) => theme.transitions.fast};
  }
`
